import { Text } from "@certn/cascadia";
import { css } from "@emotion/css";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { ClientJsonForm } from "../../components/client-json-form/ClientJsonForm";
import { Package } from "./package-creation/PackageContext";
import { getPackageClientFormPayload } from "./package-creation/package-utils";

export function PackageATSConfiguration({
  packageData,
  isSubmitted,
  titleAs,
}: {
  packageData: Package;
  isSubmitted: boolean;
  titleAs?: "h1";
}) {
  const { t } = useTranslation();
  const clientFormPayload = useMemo(
    () => getPackageClientFormPayload(packageData),
    [packageData]
  );

  return (
    <div className={styles.container} data-testid="package-ats-configuration">
      <Text as={titleAs} style="global/title-small">
        {t("Configuration")}
      </Text>
      <Text style="form/body-primary">
        {t(
          "Configure the required input fields that will be pre-populated when this package is used for ATS or API orders."
        )}
      </Text>
      <ClientJsonForm
        isSubmitted={isSubmitted}
        questionsUrl="/api/internal/client-portal/packages/client-form/"
        clientFormPayload={clientFormPayload}
        initialData={
          Object.keys(packageData.client_input_claims || {}).length > 0
            ? packageData.client_input_claims
            : undefined
        }
        isApplyLink={false}
      />
    </div>
  );
}

const styles = {
  container: css({
    display: "flex",
    flexDirection: "column",
    gap: "var(--space-3)",
  }),
};
